import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Card, CardBody, CardDeck, CardHeader, CardTitle, Container, Table } from "reactstrap";
import PolyUtil from "../../../util/PolyUtil";
import Loader from "../../display/Loader";

class TUCriminalDisplay extends Component {
    render() {
        if (!this.props.report) {
            return <Loader isLoading spin/>;
        } else if (this.props.report === null) {
            return (
                <Card className="mt-4">
                    <CardHeader>
                        <h3 className="text-info text-center">We couldn't retrieve criminal history data for this tenant</h3>
                    </CardHeader>
                    <CardBody>
                        <p>We couldn't get criminal records for this tenant from TransUnion <strong>at this time</strong>. This could be due to the following:</p>
                        <ul>
                            <li>Tenant's criminal record is expired</li>
                            <li>Tenant's criminal record hasn't been processed by TransUnion yet</li>
                            <li>An error occurred on TransUnion's side</li>
                        </ul>
                        <p>You can try to view this report at a later time, or, if this problem persists, feel free to shoot us a message via the blue message button in the bottom right of your
                            screen.</p>
                    </CardBody>
                </Card>
            );
        } else {
            const {guarantor, report} = this.props;
            return <div>
                <Container fluid style={{marginTop: '1em'}}>
                    {
                        !!guarantor && (
                            <div>
                                <CardDeck>
                                    <Card className="pr-card">
                                        <CardTitle>This report corresponds to a guarantor for the applied tenant:</CardTitle>
                                        <CardBody>
                                            <Table striped responsive>
                                                <tbody>
                                                <tr>
                                                    <th scope="row">Guarantor First Name:</th>
                                                    <td>{guarantor.first_name}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Guarantor Last Name:</th>
                                                    <td>{guarantor.last_name}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Guarantor Phone:</th>
                                                    <td>{PolyUtil.formatPhone(guarantor.phone)}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Guarantor Email:</th>
                                                    <td>{guarantor.email}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Relationship to Applicant:</th>
                                                    <td>{PolyUtil.formatTitleCase(guarantor.relation)}</td>
                                                </tr>

                                                </tbody>
                                            </Table>
                                        </CardBody>
                                    </Card>
                                </CardDeck>
                            </div>
                        )
                    }
                    <div dangerouslySetInnerHTML={{__html: report}} />
                </Container>
            </div>
        }

    }
}

export default connect()(TUCriminalDisplay);



// WEBPACK FOOTER //
// ./src/components/application/credit/TUCriminalDisplay.js